import { REMOTE_GAMES } from "./app-config.js";

export const appSize = app => ({
  explorer: [700, 470], writing: [610, 430], wiki: [720, 500], terminal: [650, 390], search: [540, 390],
  recycle: [560, 390], archive: [620, 420], notes: [570, 400], monitor: [520, 390], readme: [520, 400], reader: [680, 480],
  help: [560, 420], browser: [790, 540], photos: [760, 570], mail: [590, 430], calendar: [840, 540], media: [510, 390], network: [620, 430], control: [520, 390], minesweeper: [280, 470], minecraft: [900, 620], paint: [820, 580], calculator: [280, 360], piano: [820, 360], maths: [700, 360], "beat-maker": [1080, 550], chess: [620, 648], "dx-ball": [648, 533], trust: [960, 680], guestbook: [570, 430], socials: [540, 470], messenger: [470, 560], conversation: [620, 520], roblox: [820, 580], youtube: [850, 590], blackjack: [650, 520], sticky: [450, 390], weather: [600, 475], monitor: [520, 470], run: [420, 250], properties: [460, 390], shutdown: [470, 280]
}[app] || [520, 380]);

export const GAME_VIEWPORTS = Object.freeze({
  "dx-ball": { width: 640, height: 480, aspect: 4 / 3 },
  // The Trust canvas has large blank top and bottom margins. Use a compact
  // near-square mobile viewport to crop that unused space around the game.
  trust: { width: 980, height: 980, aspect: 1, embedWidth: 980, embedHeight: 1998 }
});

export const fittedGameWindowSize = (app, availableW, availableH, mobile = false) => {
  // Keep Trust at its normal desktop window size; its tall, portrait-like
  // storyboard is only scaled to a fitted aspect ratio on phone screens.
  if (app === "trust" && !mobile) return null;
  if (app === "chess") {
    const [baseW] = appSize(app), frameH = 28;
    const side = Math.floor(Math.min(baseW, availableW, availableH - frameH));
    return { w: side, h: side + frameH };
  }

  const game = GAME_VIEWPORTS[app];
  if (!game || !Number.isFinite(game.width) || !Number.isFinite(game.height)) return null;

  // Game-only windows omit the File/Edit menu and status strip.
  const frameW = 8, frameH = 36;
  const maxContentW = Math.max(1, Math.min(game.width, availableW - frameW));
  const maxContentH = Math.max(1, Math.min(game.height, availableH - frameH));
  const contentW = Math.min(maxContentW, maxContentH * game.aspect);
  const contentH = contentW / game.aspect;
  return { w: Math.ceil(contentW + frameW), h: Math.ceil(contentH + frameH) };
};

export const isHostedGame = app => app === "chess" || app === "dx-ball" || Boolean(REMOTE_GAMES[app]);
export const IMMERSIVE_GAME_APPS = new Set(["dx-ball", "trust"]);
export const defaultDesktopWindows = () => [];

export const COMPACT_VIEWPORT = 680;
export const taskbarHeightFor = width => width <= COMPACT_VIEWPORT ? 44 : 52;

// These utilities remain movable, windowed apps rather than maximizing.
export const NON_MAXIMIZABLE_APPS = new Set(["explorer", "minesweeper", "roblox", "piano", "chess", "dx-ball", "trust"]);

export const viewportBox = () => {
  const viewport = window.visualViewport;
  return {
    width: Math.max(280, Math.round(viewport?.width || document.documentElement.clientWidth || innerWidth)),
    height: Math.max(320, Math.round(viewport?.height || document.documentElement.clientHeight || innerHeight))
  };
};
